const plusIntroWithoutFreeTrial =
  "24/7 texting with our care team for <nobr>less than a dollar a day.</nobr>";
const premiumIntroWithoutFreeTrial =
  "24/7 text, phone, and video chat with a fertility or OB nurse and peer coach for less than the cost of a latte a day.";

const plusHeading = "$t(common.plans.plus)";
const premiumHeading = "$t(common.plans.premium)";

export const planSelect = {
  bgDesign: "Background illustration",
  cantDecide:
    "<Strong>Can't decide?</Strong> <nobr><Link>Read more about our plans here</Link></nobr>",
  discountTerm: "/next month",
  divider: "Compare Plans",
  ctas: {
    plus: "Start Plus",
    premium: "Start Premium",
  },
  currentPlanStatic: "Current Plan",
  extend: {
    postDiscountDescription: "{{priceAndTerm}} thereafter",
    premium: {
      cta: "Continue with Premium",
      heading: "Continue with $t(common.plans.premium)",
      intro:
        "Your current plan includes 24/7 text, phone, and video chatting with your care team, community events, financial coaching, bespoke fertility planning, and access to new products and discounts.",
      price: {
        amount: "$116.33",
        freeTrial: "",
        startingAt: "starting at",
        term: "/mo",
      },
    },
    plus: {
      cta: "Downgrade to Plus",
      heading: `Downgrade to $t(common.plans.plus)`,
      intro:
        "Our base plan includes text support from our care team without community events, phone and video chat, financial coaching, a curated fertility plan, and special products and discounts.",
      price: {
        amount: "$43.00",
        freeTrial: "",
        startingAt: "starting at",
        term: "/mo",
      },
    },
    subtitle: "",
    title: "Continue enjoying your Conceive membership!",
  },
  monthlyAmount: {
    plus: "$49",
    premium: "$129",
  },
  payment: {
    premium: {
      cta: "Start Premium",
      heading: premiumHeading,
      intro: premiumIntroWithoutFreeTrial,
      price: {
        amount: "$116.33",
        freeTrial: "",
        startingAt: "starting at",
        term: "/mo",
      },
    },
    plus: {
      cta: "Start Plus",
      heading: plusHeading,
      intro: plusIntroWithoutFreeTrial,
      price: {
        amount: "$43.00",
        freeTrial: "",
        startingAt: "starting at",
        term: "/mo",
      },
    },
    subtitle: "Select your plan",
    title: "Your personalized <nobr>plan is ready!</nobr>",
  },
  resubscribe: {
    premium: {
      cta: "Start Premium",
      heading: premiumHeading,
      intro: premiumIntroWithoutFreeTrial,
      price: {
        amount: "$116.33",
        freeTrial: "",
        startingAt: "starting at",
        term: "/mo",
      },
    },
    plus: {
      cta: "Start Plus",
      heading: plusHeading,
      intro: plusIntroWithoutFreeTrial,
      price: {
        amount: "$43.00",
        freeTrial: "",
        startingAt: "starting at",
        term: "/mo",
      },
    },
    subtitle: "Select your plan",
    title: "Welcome back!",
  },
  table: {
    labels: {
      plus: {
        abbreviated: "Plus",
        full: "Conceive Plus",
      },
      premium: {
        abbreviated: "Premium",
        full: "Conceive Premium",
      },
    },
    rows: [
      {
        copy: "Weekly personalized fertility and pregnancy tips from experts",
        hasPremium: true,
        hasPlus: true,
      },
      {
        copy: "24/7 text support from nurses and peer coaches (avg. response time < 20 min.)",
        hasPremium: true,
        hasPlus: true,
      },
      {
        copy: "Personalized pregnancy and postpartum support",
        hasPremium: true,
        hasPlus: true,
      },
      {
        copy: "Expert articles summarizing all you need to read",
        hasPremium: true,
        hasPlus: true,
      },
      {
        copy: "Referrals to top doctors",
        hasPremium: true,
        hasPlus: true,
      },
      {
        copy: "Community gatherings to mingle with fellow members",
        hasPremium: true,
        hasPlus: false,
      },
      {
        copy: "Monthly one-on-one sessions with a peer coach",
        hasPremium: true,
        hasPlus: false,
      },
      {
        copy: "Monthly one-on-one sessions with a fertility or OB nurse",
        hasPremium: true,
        hasPlus: false,
      },
      {
        copy: "Community events and workshopping sessions from leading experts",
        hasPremium: true,
        hasPlus: false,
      },
      {
        copy: "Fertility, prenatal, and postpartum plans to take to your medical team",
        hasPremium: true,
        hasPlus: false,
      },
      {
        copy: "A one-on-one session every month with a financial coach",
        hasPremium: true,
        hasPlus: false,
      },
      {
        copy: "Early access to new products and discounts",
        hasPremium: true,
        hasPlus: false,
      },
    ],
  },
  recommended: "Recommended for you",
  scheduledIntervalChangeBanner: {
    content:
      "You already selected to downgrade from billing {{currentInterval}} to billing {{scheduledInterval}}. This will go into effect on {{currentPeriodEndFormatted}}.",
  },
  trialBanner: {
    content:
      "Extend your Conceive subscription before {{discountEndsAt}} to get <strong>{{discount}} off your next month</strong>",
  },
  upgrade: {
    premium: {
      cta: "Upgrade to Premium",
      heading: premiumHeading,
      intro: premiumIntroWithoutFreeTrial,
      price: {
        amount: "$129",
        freeTrial: "",
        startingAt: "starting at",
        term: "/mo",
      },
    },
    plus: {
      cta: "",
      heading: plusHeading,
      intro: plusIntroWithoutFreeTrial,
      price: {
        amount: "$49",
        freeTrial: "",
        startingAt: "starting at",
        term: "/mo",
      },
    },
    subtitle: "",
    title: "Upgrade your plan",
  },
};
